import React, { FC } from 'react';
import { ReactComponent as ArrowRight } from '../../../assets/Dashboard/ArrowRight.svg';

export const ArrowRightIcon: FC = () => <ArrowRight />;
